<template>
  <div class="books-list">
    <card v-for="group in groups" :key="group.name" dis-hover :padding="0" class="books-list__group">
      <div class="books-list__header ms-help">
        {{ group.name }}
      </div>
      <ul class="books-list__container">
        <li
          :class="[
            'books-list__item ms-text',
            item.value === activeBook ? 'active' : '',
          ]"
          v-for="item in getBooksList(group.books)"
          :key="item.value"
          @click="changeBook(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </card>
  </div>
</template>

<script>
const groups = [
  {
    name: 'Платежи',
    books: ['key_words']
  },
  {
    name: 'Дополнительные сведения',
    books: [
      'job_types',
      'contragent_job_types',
      'object_types',
      'tender_type',
      'federal_districts',
      'territory_types',
      'offshore_drillings',
      'climate_conditions',
      'profile_work_regions',
      'planer_types',
      'project_stages',
      'responsibility_levels'
    ]
  },
  {
    name: 'Компания',
    books: [
      'own_company',
      'departments',
      'positions',
      'users',
      'field_managers'
    ]
  },
  {
    name: 'Компании - контрагенты',
    books: ['company_groups', 'other_company']
  },
  {
    name: 'Системные справочники',
    books: [
      'amendment_types',
      'procedure_types',
      'expertise_types'
    ]
  },
  {
    name: 'Банковские гарантии',
    books: [
      'bg_types',
      'banks'
    ]
  }
]

export default {
  props: ['active-book', 'books'],
  data () {
    return {
      groups
    }
  },
  methods: {
    getBooksList (groupBooks) {
      return this.books.filter(({ id }) => groupBooks.includes(id))
    },
    changeBook (book) {
      this.$emit('change-book', book)
    }
  }
}
</script>

<style lang="less">
.books-list {
  &__group {
    &:not(:first-child) {
      margin-top: 8px;
    }
  }

  &__header {
    padding: 8px;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    border-bottom: 1px solid #e8eaec;
  }

  &__container {
    list-style-type: none;
    padding: 8px 0;
  }

  &__item {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background-color: rgba(@primary-color, 0.2);
    }

    &.active {
      font-weight: bold;
      background-color: rgba(@primary-color, 0.3);
    }
  }
}

.dark {
  .books-list {
    &__header {
      border-color: rgba(@dt-dark-primary, 0.6) !important;
    }
  }
}
</style>
